<template>
  <div class="d-flex flex-column flex-grow-1 mr-2 mb-2 rounded">
    <BaseToolBar title="Commandes" subtitle="Liste des commandes disponibles">
      <!-- Filtre par état -->
      <div class="d-flex align-items-center mr-3">
        <label class="mr-2 text-muted">Filtrer par état :</label>
        <select
          class="form-control"
          style="width: 200px;"
          v-model="filtreEtatId"
        >
          <option value="">Tous les états</option>
          <option v-for="etat in data.etats" :key="etat.id" :value="etat.id">
            {{ etat.description }}
          </option>
        </select>
      </div>

      <BaseButton
        class="btn btn-primary ml-3"
        v-tooltip="'Ajouter une demande'"
        @click="storeCommande"
        :loading="loading"
        icon="plus"
      ></BaseButton>
    </BaseToolBar>
    <div class="d-flex flex-column flex-md-row w-100">
      <div class="flex-grow-1 d-flex flex-column">
        <div
          v-for="commande in commandesFiltrees"
          :key="'actives_' + commande.id"
        >
          <commandes-item
            :commande="commande"
            v-if="commande.etat_id !== 1"
          ></commandes-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMultiRowFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

import BaseButton from "@/components/bases/Button.vue";
import CommandesItem from "@/components/materiels/CommandesItem.vue";
import BaseToolBar from "@/components/bases/ToolBar.vue";

export default {
  components: {
    CommandesItem,
    BaseToolBar,
    BaseButton
  },
  data() {
    return {
      loading: false,
      feedback: {},
      filtreEtatId: "" // Filtre pour l'état des commandes
    };
  },
  methods: {
    ...mapActions({
      _storeCommande: "materiel/createCommande"
    }),
    storeCommande: function() {
      this.feedback = {};
      this.loading = true;
      this._storeCommande()
        //.catch(error => ())
        .finally(() => (this.loading = false));
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      data: "materiel/data"
    }),
    ...mapMultiRowFields("materiel", ["commandes"]),

    // Computed property pour filtrer les commandes par état
    commandesFiltrees() {
      if (!this.filtreEtatId) {
        return this.commandes; // Retourner toutes les commandes si aucun filtre
      }
      return this.commandes.filter(
        commande => commande.etat_id == this.filtreEtatId
      );
    }
  }
};
</script>
